import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import { RewardProviderType } from '@kudos/http-client'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const RewardsProvidersRoute = lazyWithRetries(() => import('.'))
const TangoRewardsRoute = lazyWithRetries(() => import('./rewardProvider/tango'))
const TangoRewardRoute = lazyWithRetries(() => import('./rewardProvider/tango/reward'))
const CustomRewardRoute = lazyWithRetries(() => import('./rewardProvider/custom/reward'))
const RedemptionHistoryRoute = lazyWithRetries(() => import('./redemptionHistory'))
const CustomRewardsRoute = lazyWithRetries(() => import('./rewardProvider/custom'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.rewardsProviders(),
    element: (
      <StandardPageLayout
        elementId="rewardsProviderRoute"
        maxWidth={600}
        title={<T _str="Rewards" />}>
        <Suspense fallback={<RouteLoading />}>
          <RewardsProvidersRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.rewardStore(RewardProviderType.TANGO, ':rewardProviderId'),
    element: (
      <StandardPageLayout
        elementId="tangoRewardProvider"
        maxWidth={1080}
        title={<T _str="Rewards" />}>
        <Suspense fallback={<RouteLoading />}>
          <TangoRewardsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.rewardStore(RewardProviderType.CUSTOM, ':rewardProviderId'),
    element: (
      <StandardPageLayout
        elementId="customRewardProvider"
        maxWidth={1080}
        title={<T _str="Rewards" />}>
        <Suspense fallback={<RouteLoading />}>
          <CustomRewardsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.redemptionHistory(),
    element: (
      <StandardPageLayout
        elementId="redemptionHistory"
        maxWidth={1440}
        title={<T _str="Redemption history" />}>
        <Suspense fallback={<RouteLoading />}>
          <RedemptionHistoryRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.reward(':rewardProviderId', ':rewardId', RewardProviderType.TANGO),
    element: (
      <StandardPageLayout elementId="tangoReward" maxWidth={600}>
        <Suspense fallback={<RouteLoading />}>
          <TangoRewardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.reward(':rewardProviderId', ':rewardId', RewardProviderType.CUSTOM),
    element: (
      <StandardPageLayout elementId="customReward" maxWidth={600}>
        <Suspense fallback={<RouteLoading />}>
          <CustomRewardRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
